const portalSessionResetEventName = 'portal-session-reset-requested'

export const requestPortalSessionReset = (): void => {
    window.dispatchEvent(new Event(portalSessionResetEventName))
}

export const addPortalSessionResetListener = (listener: () => void): (() => void) => {
    window.addEventListener(portalSessionResetEventName, listener)

    return () => {
        window.removeEventListener(portalSessionResetEventName, listener)
    }
}
